import React from 'react';
import PropTypes from 'prop-types';

import CarouselBaseContainer from 'components/carousel/CarouselBaseContainer';

const propTypes = {
  items: PropTypes.array.isRequired,
  assignCarouselRef: PropTypes.func.isRequired,
  themeId: PropTypes.number.isRequired,
};

const CarouselThemePackages = ({ items, assignCarouselRef, themeId }) => (
  <CarouselBaseContainer
    items={items}
    nSettings={{
      dots: false,
      arrows: false,
      autoplay: false,
      initialSlide: 1,
      slidesToShow: 1,
      centerPadding: '0',
      variableWidth: true,
      swipeToSlide: true,
      rows: 1,
      slidesPerRow: 1,
      pauseOnFocus: true,
      lazyLoad: 'progressive',
      className: `carousel-theme-${themeId}-packages`,
    }}
    assignCarouselRef={assignCarouselRef}
  />
);

CarouselThemePackages.propTypes = propTypes;

export default CarouselThemePackages;
